import { AccordionCore } from "./AccordionCore.js";
import { AccordionItem } from "./AccordionItem.js";
class Accordion extends AccordionCore {
  static config = {
    ...AccordionCore.config,
    components: {
      AccordionItem
    }
  };
}
export {
  Accordion
};
//# sourceMappingURL=Accordion.js.map
